module.exports = __webpack_public_path__ + "img/Guirlande_de_noel.a7a3c19.jpg";